/* eslint-disable no-dupe-keys */
export default {
  vip_charge_station: {
    name: '会员充电站',
    // 属性（一般与对象内容匹配）
    prop: {
      charge_station: '充电站',
      discount_type: '会员优惠方式',
      billing_rule: '站当前费率名称',
      service_fee_discount_rate: '服务费折扣百分比',
      created_at: '创建时间',
      updated_at: '更新时间',
      service_provider: '运营商',
      member_day_participated: '会员优惠日'
    },
    // Enum的属性
    discount_types: {
      billing_rule_discount: '费率',
      service_fee_discount: '服务费折扣'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '电站名称、地址'
    },
    // 详情页标签
    // 参与会员优惠日
    member_day_participateds: {
      true: '参与',
      false: '不参与'
    },
    // 标题
    titles: {
      base_info: '基本信息',
      billing_rule: '会员充电费率'
    },
    time_types: {
      sharp_peak: '尖',
      peak: '峰',
      flat: '平',
      valley: '谷',
      unknown: '普'
    }
  }
}
